export const SET_CURRENT_TAB = "SET_CURRENT_TAB";

export const setCurrentTab = (tabNumber) => ({
  type: SET_CURRENT_TAB,
  payload: tabNumber
});